// extracted by mini-css-extract-plugin
module.exports = {"primary":"#6ac8e8","text-primary":"#ffffff","background-accent":"#333744","background":"#424757","light-gray":"#cccccc","error":"#fd9d9a","danger":"#fd9d9a","link":"#7cbbff"};